<template>
  <div :class="['fits-for-lazy', { 'element--is-loading element--is-loading--at-top': loading }]">
    <div v-if="loading" class="fits-for-lazy__placeholder"></div>
    <template v-else-if="fitsFor && fitsFor.length">
      <section
        v-for="categoryItem in fitsFor"
        :key="categoryItem.name"
        class="fits-for-category">
        <h3 class="fits-for-category__headline">
          {{ categoryItem.name }}
        </h3>
        <section
          v-for="brand in categoryItem.nextLevel"
          :key="brand.name"
          class="fits-for-category__brand-container">
          <h4 class="fits-for-category__brand-headline">
            {{ brand.name }}
          </h4>
          <ul class="grid grid--five grid--no-gap">
            <li
              v-for="model in flattenModels(brand)"
              :key="model.name"
              class="fits-for-category__models-li">
              <a :href="model.url" class="fits-for-category__models-link">{{ model.name }}</a>
            </li>
          </ul>
        </section>
      </section>
    </template>
  </div>
</template>

<script>
import httpService from '@/core/http-service'
import EventBus from '@/core/event-bus'

export default {
  name: 'FitsForLazy',
  props: {
    productCode: {
      type: String,
      required: true
    },
    itemCode: {
      type: String,
      default: null
    },
    category: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      loaded: false,
      fitsFor: null
    }
  },
  mounted() {
    // Start fetching immediately so vehicle selector shows loading state from page load
    this.load()

    const contentPanel = this.$el.closest('.product-tabs__accordion-content')
    if (!contentPanel) return

    // If tab is already open, nothing more to do — load() already called
    if (contentPanel.getAttribute('aria-hidden') === 'false') return

    // Watch for tab open to trigger render (data may already be loaded by then)
    this._observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'aria-hidden' &&
          contentPanel.getAttribute('aria-hidden') === 'false'
        ) {
          this._observer.disconnect()
          break
        }
      }
    })
    this._observer.observe(contentPanel, { attributes: true, attributeFilter: ['aria-hidden'] })
  },
  beforeDestroy() {
    if (this._observer) {
      this._observer.disconnect()
    }
  },
  methods: {
    async load() {
      if (this.loaded || this.loading) return
      this.loading = true
      EventBus.fitsForLoading = true
      EventBus.$emit('fitsfor.loading')
      try {
        const params = { productCode: this.productCode }
        if (this.itemCode) params.itemCode = this.itemCode
        if (this.category) params.category = this.category
        const response = await httpService.get('fitsfor', params)
        this.fitsFor = response.data
        this.loaded = true
      } catch (e) {
        this.fitsFor = []
      } finally {
        this.loading = false
        EventBus.fitsForLoading = false
        EventBus.$emit('fitsfor.loaded')
      }
    },
    flattenModels(node) {
      const results = []
      const walk = (n) => {
        if (n.isModel) results.push(n)
        if (n.nextLevel && n.nextLevel.length) {
          n.nextLevel.forEach(walk)
        }
      }
      walk(node)
      return results
    }
  }
}
</script>
